import { compose, withHandlers, withProps, withState } from 'recompose';
import PromoTidalReservation from '../components/PromoTidalReservation';

export default compose(
  withProps(props => ({
    promoUrl: `https://offer.tidal.com/voucher?code=${props.promoCode}`,
  })),
  withState('showCopiedMessageClass', 'setshowCopiedMessageClass', false),
  withHandlers({
    onCopyClick: props => () => {
      navigator.clipboard.writeText(props.promoCode);

      props.setshowCopiedMessageClass(true);
      setTimeout(() => props.setshowCopiedMessageClass(false), 3000);
    },
  }),
)(PromoTidalReservation);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PromoTidalReservation.jsx